import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { INDICATOR_CARD_WIDTH } from 'modules/decision/constants';

import IndicatorCardPaper from './IndicatorCardPaper';

const IndicatorCardSkeleton = () => (
    <IndicatorCardPaper sx={{ width: `min(25vw, ${INDICATOR_CARD_WIDTH}px)` }}>
        <Stack sx={{ gap: 1 }}>
            <Skeleton variant="text" width="65%" height={24} />
            <Skeleton variant="rectangular" height={180} />
            <Skeleton variant="text" />
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="55%" />
        </Stack>
        <Skeleton variant="rounded" height={36} />
    </IndicatorCardPaper>
);

export default IndicatorCardSkeleton;
